module.exports = __webpack_public_path__ + "img/causa-moveis.673bfa47.jpeg";